// extracted by mini-css-extract-plugin
export default {"main-hero_search":"main-hero-block_main-hero_search__Xxs8D"};